module.exports = __webpack_public_path__ + "img/three3Orange.4afd0054.jpg";